// extracted by mini-css-extract-plugin
module.exports = {"latest-issues":"styles-m__latest-issues__1flx9","figure":"styles-m__figure__1GNih"};